"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const taskStore_1 = require("../taskStore");
const helpers_1 = require("./shared/helpers");
const timeline_1 = __importDefault(require("./math/timeline"));
const timeline_2 = __importDefault(require("./matrix-reasoning/timeline"));
const timeline_3 = __importDefault(require("./mental-rotation/timeline"));
// @ts-ignore
const timeline_4 = __importDefault(require("./hearts-and-flowers/timeline"));
const timeline_5 = __importDefault(require("./memory-game/timeline"));
const timeline_6 = __importDefault(require("./same-different-selection/timeline"));
const catTimeline_1 = __importDefault(require("./same-different-selection/catTimeline"));
const timeline_7 = __importDefault(require("./vocab/timeline"));
const timeline_8 = __importDefault(require("./theory-of-mind/timeline"));
const timeline_9 = __importDefault(require("./intro/timeline"));
const timeline_10 = __importDefault(require("./trog/timeline"));
const timeline_11 = __importDefault(require("./roar-inference/timeline"));
const timeline_12 = __importDefault(require("./adult-reasoning/timeline"));
const timeline_13 = __importDefault(require("./child-survey/timeline"));
const catTimeline_2 = __importDefault(require("./mental-rotation/catTimeline"));
// TODO: Abstract to import config from specifc task folder
// Will allow for multiple devs to work on the repo without merge conflicts
exports.default = {
    // Need to change bucket name to match task name (math)
    egmaMath: {
        setConfig: helpers_1.setSharedConfig,
        getCorpus: helpers_1.getCorpus,
        getTranslations: helpers_1.getTranslations,
        buildTaskTimeline: timeline_1.default,
        variants: {
            // example
            egmaMathKids: {
            // does not need to have all properties, only what is different from base task
            },
        },
    },
    matrixReasoning: {
        setConfig: helpers_1.setSharedConfig,
        getCorpus: helpers_1.getCorpus,
        getTranslations: helpers_1.getTranslations,
        buildTaskTimeline: timeline_2.default,
        variants: {},
    },
    mentalRotation: {
        setConfig: helpers_1.setSharedConfig,
        getCorpus: helpers_1.getCorpus,
        getTranslations: helpers_1.getTranslations,
        buildTaskTimeline: (config, mediaAssets) => (0, taskStore_1.taskStore)().runCat
            ? (0, catTimeline_2.default)(config, mediaAssets)
            : (0, timeline_3.default)(config, mediaAssets),
        variants: {},
    },
    heartsAndFlowers: {
        setConfig: helpers_1.setSharedConfig,
        getCorpus: helpers_1.getCorpus,
        getTranslations: helpers_1.getTranslations,
        buildTaskTimeline: timeline_4.default,
        variants: {},
    },
    memoryGame: {
        setConfig: helpers_1.setSharedConfig,
        getCorpus: helpers_1.getCorpus,
        getTranslations: helpers_1.getTranslations,
        buildTaskTimeline: timeline_5.default,
        variants: {},
    },
    sameDifferentSelection: {
        setConfig: helpers_1.setSharedConfig,
        getCorpus: helpers_1.getCorpus,
        getTranslations: helpers_1.getTranslations,
        buildTaskTimeline: (config, mediaAssets) => (0, taskStore_1.taskStore)().runCat
            ? (0, catTimeline_1.default)(config, mediaAssets)
            : (0, timeline_6.default)(config, mediaAssets),
        variants: {},
    },
    trog: {
        setConfig: helpers_1.setSharedConfig,
        getCorpus: helpers_1.getCorpus,
        getTranslations: helpers_1.getTranslations,
        buildTaskTimeline: timeline_10.default,
        variants: {},
    },
    vocab: {
        setConfig: helpers_1.setSharedConfig,
        getCorpus: helpers_1.getCorpus,
        getTranslations: helpers_1.getTranslations,
        buildTaskTimeline: timeline_7.default,
    },
    theoryOfMind: {
        setConfig: helpers_1.setSharedConfig,
        getCorpus: helpers_1.getCorpus,
        getTranslations: helpers_1.getTranslations,
        buildTaskTimeline: timeline_8.default,
        variants: {},
    },
    intro: {
        setConfig: helpers_1.setSharedConfig,
        getCorpus: helpers_1.getCorpus,
        getTranslations: helpers_1.getTranslations,
        buildTaskTimeline: timeline_9.default,
        variants: {},
    },
    roarInference: {
        setConfig: helpers_1.setSharedConfig,
        getCorpus: helpers_1.getCorpus,
        getTranslations: helpers_1.getTranslations,
        buildTaskTimeline: timeline_11.default,
        variants: {
            // example
            inferenceKids: {
            // does not need to have all properties, only what is different from base task
            },
        },
    },
    adultReasoning: {
        setConfig: helpers_1.setSharedConfig,
        getCorpus: helpers_1.getCorpus,
        getTranslations: helpers_1.getTranslations,
        buildTaskTimeline: timeline_12.default,
        variants: {},
    },
    hostileAttribution: {
        setConfig: helpers_1.setSharedConfig,
        getCorpus: helpers_1.getCorpus,
        getTranslations: helpers_1.getTranslations,
        buildTaskTimeline: timeline_8.default,
        variants: {},
    },
    childSurvey: {
        setConfig: helpers_1.setSharedConfig,
        getCorpus: helpers_1.getCorpus,
        getTranslations: helpers_1.getTranslations,
        buildTaskTimeline: timeline_13.default,
        variants: {},
    },
};
